// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex[data-v-2930869e] {\n  display: flex;\n  justify-content: space-between;\n}\n.box[data-v-2930869e] {\n  margin: 0 0.26667rem;\n}\n.box .label[data-v-2930869e] {\n  font-weight: 500;\n  font-size: 0.37333rem;\n  color: rgba(0, 0, 0, 0.85);\n  line-height: 0.58667rem;\n}\n.box .block[data-v-2930869e] {\n  width: 0.74667rem;\n  height: 0.05333rem;\n  background: #f87a1b;\n  margin: 0 auto;\n}\n", ""]);
// Exports
module.exports = exports;
